function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#012169"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15L0,7.5Z",
    style: {
      fill: "#0db02b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 2.709,
    style: {
      fill: "#f7d116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.344,13.782c.186.255.465.681.693.57.177,0,.267.012.291.129.417.072,1.116-.105,1.548-.672,0,0,.036.006.024-.21.003-.093.129-.075.132-.045.018.048.015.081.039.084.054-.018.126-.138.189-.213.018-.033.009-.069.012-.111.033-.081.114-.063.129-.021.015.027.015.048.03.075.081.054.231.003.24.003.015-.066.057-.06.057-.06.054-.012.033-.006.069.012-.033.36.072.375.063.561.003.207-.063.264-.063.342.021.096.324.099.219.18-.093.051,0,.144-.141.18-.411.21-.492.387-.492.387,0,0-.102.195-.114.195-.069.129-.156.06-.204.123-.024.081-.051.258-.003.348.024.126-.003.195-.033.321-.027.264-.132.303-.144.396-.048.099.009.564-.036.564-.306.006-.543-.06-.663-.084.117-.51.072-.957.072-1.002-.03-.363-.546-.276-.624-.324-.066-.015-.105-.066-.129-.09-.072-.009-.099-.024-.174-.033-.036.018-.015.036-.096.063-.207.024-.297-.18-.297-.18.009-.069-.462.015-.72-.045-.105.06-.15.231-.237.252-.003.054-.141-.045-.171-.096-.006-.153.135-.222.135-.222.111-.078.177-.09.231-.144.027-.135.012-.234.069-.333.048-.078.12-.042.168-.075.051-.033.075-.261.027-.321l-.219-.198c-.066-.195.081-.318.123-.306",
    style: {
      fill: "#0db02b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.646,13.227l-.384-.357-.387.354.042-.522-.516-.084.435-.294-.258-.456.501.156.195-.486.189.489.501-.15-.264.453.429.3-.519.075.036.522ZM7.002,17.565l-.414-.276-.402.291.141-.468-.408-.282.501-.012.15-.465.168.459.501-.006-.396.297.159.462ZM5.721,21.3l-.384-.357-.387.351.042-.522-.516-.084.435-.294-.258-.456.501.156.195-.486.189.489.501-.15-.264.453.429.3-.519.075.036.525ZM2.283,16.926l-.384-.357-.387.351.042-.522-.516-.084.435-.294-.258-.456.501.156.195-.486.189.489.501-.15-.264.453.429.3-.519.075.036.525ZM8.898,15.78l-.384-.36-.387.354.042-.522-.516-.084.435-.294-.258-.456.501.156.195-.486.189.489.501-.15-.264.453.429.3-.519.075.036.525Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.236,13.14c-.105-.06-.177-.012-.318-.06-.117-.039-.096-.081-.198-.114-.12-.039-.177.012-.384.033-.072.006-.186.015-.252.006-.267-.036-.477-.45-.564-.765-.117-.408-.036-.687-.09-1.275-.012-.132-.042-.324-.114-.537-.051-.153-.153-.393-.648-.969-.549-.636-.987-.99-1.104-1.083-.186-.15-.351-.264-.471-.345.018.186.06.462.162.777.117.366.261.627.399.876.231.414.813,1.443.732,1.743-.006.018-.024.081-.042.174-.024.123-.03.225-.033.294-.075-.024-.189-.066-.324-.132-.249-.123-.411-.252-.492-.315-.222-.168-.438-.243-.867-.399-.57-.207-1.104-.288-1.533-.315.27.393.534.657.729.822.363.312.747.525.936.63.231.129.327.165.567.318.369.237.51.39.6.51.111.147.213.282.237.48.024.192-.03.399-.192.657-.468.741-1.365,1.149-1.638,1.266-.342.147-.879.375-1.68.489-.606.087-1.569.135-2.745-.183.123.054.261.108.411.156.162.051.312.087.45.114.009.003-.192.009-.396-.036-.246-.054-.441-.15-.576-.231.102.081.261.192.465.282.264.117.534.171,1.332.174.48.003.72.003.957-.021.678-.069,1.185-.234,1.665-.399.405-.138.75-.255,1.197-.486.645-.336.951-.624,1.668-.915.225-.09.339-.138.483-.18.426-.126.588-.093.882-.258.264-.147.348-.297.372-.342.039-.072.045-.117.087-.171.111-.141.306-.147.456-.129-.018-.039-.06-.099-.126-.141M27.66,13.278c-.018.024-.051.033-.078.027-.039-.012-.066-.054-.063-.105l-.09-.048h.231c.027.039.024.093,0,.126",
    style: {
      fill: "#f7d116"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCx);
export default __webpack_public_path__ + "static/media/CX.ee4fb74b5e94bcb2c87ef476f5a735eb.svg";
export { ForwardRef as ReactComponent };